import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CheckCircle } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-petrol" data-id="element-155">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-petrol-light/20 via-petrol to-petrol -z-10" data-id="element-156"></div>

      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="w-full" data-id="element-158">
          <div className="inline-block px-3 py-1 rounded-full border border-gold/30 bg-gold/10 text-gold-light font-medium text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-159">
            📚 Mega Pack Química en el Aula
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6 text-white" data-id="element-160">
            Todo tu año de Química{' '}
            <span className="text-gold-gradient" data-id="element-161">resuelto en una tarde.</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="relative w-full max-w-[260px] sm:max-w-md md:max-w-xl mb-4 sm:mb-6" data-id="element-162">
          <div className="absolute inset-0 bg-gold/20 blur-[80px] rounded-full" data-id="element-163"></div>
          <img src="https://cdn.magicpatterns.com/uploads/kP451wKx4QxGYEzKEkv9ZV/seguridad_e_higiene_(3).png" alt="Mega Pack Química en el Aula" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-164" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="w-full" data-id="element-165">
          <p className="text-sm sm:text-lg md:text-xl text-gray-300 leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-166">
            El sistema completo para planificar, enseñar y evaluar — listo para
            usar desde hoy.
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-167">
            <Button href="#pricing" className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-168">
              🟡 QUIERO MI MEGA PACK AHORA
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-gray-300" data-id="element-169">
            <div className="flex items-center gap-1.5" data-id="element-170">
              <CheckCircle size={14} className="text-success" data-id="element-171" />
              <span data-id="element-172">6 tomos premium</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-173">
              <CheckCircle size={14} className="text-success" data-id="element-174" />
              <span data-id="element-175">4 bonos estratégicos</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-176">
              <CheckCircle size={14} className="text-success" data-id="element-177" />
              <span data-id="element-178">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-179">
              <CheckCircle size={14} className="text-success" data-id="element-180" />
              <span data-id="element-181">Pago en tu moneda local</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}